import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["aria-label"];
const _hoisted_2 = ["aria-current", "onClick"];
const _hoisted_3 = { class: "bottom-nav__icon-wrap" };
const _hoisted_4 = {
    key: 0,
    class: "bottom-nav__badge"
};
const _hoisted_5 = {
    key: 1,
    class: "bottom-nav__badge bottom-nav__badge--dot",
    "aria-hidden": "true"
};
const _hoisted_6 = { class: "bottom-nav__label" };
import { computed } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { getBottomNavTabs, } from "@/navigation/appSections";
import { useBottomNavShell } from "@/composables/useBottomNavShell";
import { canAccessMessaging } from "@/composables/useMessagingNavigation";
import { useMessagingStore } from "@/store/messagingStore";
import { useCursoStore } from "@/store/cursoStore";
export default /*@__PURE__*/ _defineComponent({
    __name: 'BottomNavigation',
    setup(__props) {
        const router = useRouter();
        const { t } = useI18n();
        const messagingStore = useMessagingStore();
        const cursoStore = useCursoStore();
        const { showBottomNav, activeSection, activeCurso } = useBottomNavShell();
        const tabs = computed(() => getBottomNavTabs(activeCurso.value));
        const messagingUnreadBadge = computed(() => messagingStore.unreadBadgeLabel);
        const messagingHasUnreadDot = computed(() => !messagingStore.unreadBadgeLabel && messagingStore.hasUnreadConversations);
        const messagingRootName = () => {
            const curso = cursoStore.selectedCursoData || cursoStore.getCursoData();
            if (!canAccessMessaging(curso)) {
                return "messaging-unavailable";
            }
            return "messaging-conversations";
        };
        const onTabClick = async (tab) => {
            const targetName = tab.section === "messaging" ? messagingRootName() : tab.rootRouteName;
            if (activeSection.value === tab.section) {
                if (router.currentRoute.value.name !== targetName) {
                    await router.push({ name: targetName });
                }
                return;
            }
            await router.push({ name: targetName });
        };
        return (_ctx, _cache) => {
            return (_unref(showBottomNav))
                ? (_openBlock(), _createElementBlock("nav", {
                    key: 0,
                    class: "bottom-nav app-bottom-nav-safe",
                    role: "navigation",
                    "aria-label": _unref(t)('nav.ariaLabel')
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
                        return (_openBlock(), _createElementBlock("button", {
                            key: tab.section,
                            type: "button",
                            class: _normalizeClass(["bottom-nav__item", { 'bottom-nav__item--active': _unref(activeSection) === tab.section }]),
                            "aria-current": _unref(activeSection) === tab.section ? 'page' : undefined,
                            onClick: ($event) => (onTabClick(tab))
                        }, [
                            _createElementVNode("span", _hoisted_3, [
                                _createElementVNode("i", {
                                    class: _normalizeClass(tab.icon),
                                    "aria-hidden": "true"
                                }, null, 2),
                                (tab.section === 'messaging' && messagingUnreadBadge.value)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(messagingUnreadBadge.value), 1))
                                    : (tab.section === 'messaging' && messagingHasUnreadDot.value)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_5))
                                        : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)(tab.labelKey)), 1)
                        ], 10, _hoisted_2));
                    }), 128))
                ], 8, _hoisted_1))
                : _createCommentVNode("", true);
        };
    }
});
